// extracted by mini-css-extract-plugin
module.exports = {"container":"TableRow_container__sIwOi","textContent":"TableRow_textContent__R9sSC","label":"TableRow_label__pqUnp","description":"TableRow_description__Y4DeT"};